module.exports = __webpack_public_path__ + "9ba873e2bf20a98b4bce949c21cc53fb.pdf";